module.exports = __webpack_public_path__ + "img/17.af7d57da.png";